// Small flag icons for the share kit's language switch. SVG rather than emoji:
// Windows doesn't draw flag emoji (it shows the letters "PT" / "GB").

import React, { useId } from 'react';

export function PortugalFlag({ className }) {
  return (
    <svg viewBox="0 0 30 20" className={className} aria-hidden="true">
      <rect width="30" height="20" fill="#DA291C" />
      <rect width="12" height="20" fill="#046A38" />
      <circle cx="12" cy="10" r="4.6" fill="none" stroke="#FFE000" strokeWidth="1.6" />
      <path d="M10 7.4h4v3.6a2 2 0 0 1-4 0z" fill="#fff" stroke="#DA291C" strokeWidth="0.9" />
    </svg>
  );
}

export function UkFlag({ className }) {
  const clip = useId();
  return (
    <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
      <clipPath id={clip}>
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      <path
        d="M0,0 L60,30 M60,0 L0,30"
        clipPath={`url(#${clip})`}
        stroke="#C8102E"
        strokeWidth="4"
      />
      <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
      <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}
